const adminRoot = document.querySelector("[data-admin-root]");

function initAdminPortfolioContent() {
  const store = window.NMPortfolioContent;
  const categories = window.NMCategoriesContent;
  if (!store || !adminRoot || window.NMAdminPortfolioContent) return;

  const contentHome = document.querySelector("[data-content-home]");
  const portfolioEditor = document.querySelector('[data-content-editor="portfolio"]');
  const aboutEditor = document.querySelector('[data-content-editor="about"]');
  const homeEditor = document.querySelector('[data-content-editor="home"]');
  const contactsEditor = document.querySelector('[data-content-editor="contacts"]');
  const servicesEditor = document.querySelector('[data-content-editor="services"]');
  const categoriesEditor = document.querySelector('[data-content-editor="categories"]');
  const categoriesItemEditor = document.querySelector('[data-content-editor="categories-item"]');
  const projectList = document.querySelector("[data-portfolio-list]");
  const projectCount = document.querySelector("[data-portfolio-count]");
  const projectCreateBtn = document.querySelector("[data-portfolio-create]");
  const projectModal = document.querySelector("[data-portfolio-modal]");
  const projectForm = document.querySelector("[data-portfolio-form]");
  const projectFormTitle = document.querySelector("[data-portfolio-form-title]");
  const projectImageInput = document.querySelector("#portfolio-image");
  const projectImageData = document.querySelector("[data-portfolio-image-data]");
  const projectImagePreview = document.querySelector("[data-portfolio-image-preview]");
  const projectImageReset = document.querySelector("[data-portfolio-image-reset]");

  let editingProjectId = null;

  function clearProjectErrors() {
    document.querySelectorAll("[data-portfolio-field]").forEach((field) => {
      field.classList.remove("has-error");
      const error = field.querySelector("[data-portfolio-error]");
      if (error) error.hidden = true;
    });
  }

  function showProjectError(name) {
    const field = document.querySelector(`[data-portfolio-field="${name}"]`);
    if (!field) return;
    field.classList.add("has-error");
    const error = field.querySelector("[data-portfolio-error]");
    if (error) error.hidden = false;
  }

  function updateImagePreview(src) {
    if (!projectImagePreview) return;
    const img = projectImagePreview.querySelector("img");
    if (!src) {
      projectImagePreview.hidden = true;
      if (img) img.src = "";
      return;
    }
    if (img) img.src = src;
    projectImagePreview.hidden = false;
  }

  function closeProjectModal() {
    if (projectModal) projectModal.hidden = true;
    document.body.classList.remove("is-admin-modal-open");
    editingProjectId = null;
    if (projectForm) projectForm.reset();
    if (projectImageData) projectImageData.value = "";
    clearProjectErrors();
    updateImagePreview("");
  }

  function openProjectModal() {
    if (!projectModal) return;
    projectModal.hidden = false;
    document.body.classList.add("is-admin-modal-open");
  }

  function fillCategoryOptions(selectedKey) {
    const select = projectForm?.elements?.category;
    if (!select) return;

    const list = (categories?.getCategories?.() || store.getCategories());
    const preferred = selectedKey || select.value || list[0]?.key || "";

    select.innerHTML = list.map((item) => (
      `<option value="${store.escapeHtml(item.key)}">${store.escapeHtml(item.title)}</option>`
    )).join("");

    if (preferred && list.some((item) => item.key === preferred)) {
      select.value = preferred;
    } else if (list[0]) {
      select.value = list[0].key;
    }
  }

  function fillProjectForm(project) {
    if (!projectForm) return;
    fillCategoryOptions(project?.category);
    projectForm.elements.id.value = project?.id || "";
    projectForm.elements.title.value = project?.title || "";
    projectForm.elements.shortDesc.value = project?.shortDesc || "";
    projectForm.elements.description.value = project?.description || "";
    projectForm.elements.showOnHome.checked = project ? Boolean(project.showOnHome) : true;
    if (projectImageData) projectImageData.value = project?.image || "";
    updateImagePreview(project?.image || (project ? store.resolveProjectImage(project, 0) : ""));
  }

  function renderProjectsAdmin() {
    if (!projectList) return;
    const data = store.getPortfolioData();
    const projects = data.projects || [];
    const categoryMap = store.getCategoryMap();

    if (projectCount) {
      projectCount.textContent = projects.length
        ? `Проектов: ${projects.length}`
        : "Проектов пока нет";
    }

    if (!projects.length) {
      projectList.innerHTML = `
        <div class="admin-panel__projects-empty">
          <p class="admin-panel__projects-empty-title">Пока нет проектов</p>
          <p class="admin-panel__hint p3">Добавьте первый проект — превью, категория и текст во всплывающем окне</p>
        </div>
      `;
      return;
    }

    projectList.innerHTML = projects.map((item, index) => {
      const categoryTitle = categoryMap[item.category]?.title || item.category || "Без категории";
      const shortDesc = item.shortDesc || "Краткое описание не указано";
      return `
        <article class="admin-panel__project-card">
          <div class="admin-panel__project-card-media">
            <img src="${store.escapeHtml(store.resolveProjectImage(item, index))}" alt="" width="96" height="96" />
          </div>
          <div class="admin-panel__project-card-body">
            <div class="admin-panel__project-card-top">
              <h4 class="admin-panel__project-card-title">${store.escapeHtml(item.title)}</h4>
              <div class="admin-panel__project-card-tags">
                <span class="admin-panel__project-tag">${store.escapeHtml(categoryTitle)}</span>
                ${item.showOnHome ? '<span class="admin-panel__project-tag admin-panel__project-tag_home">На главной</span>' : ""}
              </div>
            </div>
            <p class="admin-panel__project-card-desc">${store.escapeHtml(shortDesc)}</p>
          </div>
          <div class="admin-panel__project-card-actions">
            <button class="admin-panel__action-btn" type="button" data-portfolio-edit="${store.escapeHtml(item.id)}">Изменить</button>
            <button class="admin-panel__action-btn admin-panel__action-btn_danger" type="button" data-portfolio-delete="${store.escapeHtml(item.id)}">Удалить</button>
          </div>
        </article>
      `;
    }).join("");
  }

  function showPortfolioEditor() {
    if (contentHome) contentHome.hidden = true;
    if (aboutEditor) aboutEditor.hidden = true;
    if (homeEditor) homeEditor.hidden = true;
    if (contactsEditor) contactsEditor.hidden = true;
    if (servicesEditor) servicesEditor.hidden = true;
    if (categoriesEditor) categoriesEditor.hidden = true;
    if (categoriesItemEditor) categoriesItemEditor.hidden = true;
    const articlesEditor = document.querySelector('[data-content-editor="articles"]');
    const articlesItemEditor = document.querySelector('[data-content-editor="articles-item"]');
    if (articlesEditor) articlesEditor.hidden = true;
    if (articlesItemEditor) articlesItemEditor.hidden = true;
    const faqEditor = document.querySelector('[data-content-editor="faq"]');
    if (faqEditor) faqEditor.hidden = true;
    if (portfolioEditor) portfolioEditor.hidden = false;
    renderProjectsAdmin();
    closeProjectModal();
  }

  function openCreateProject() {
    const list = categories?.getCategories?.() || store.getCategories();
    if (!list.length) {
      window.alert("Сначала добавьте хотя бы одну категорию в разделе «Категории»."); // eslint-disable-line no-alert
      return;
    }
    editingProjectId = null;
    if (projectFormTitle) projectFormTitle.textContent = "Новый проект";
    fillProjectForm(null);
    if (projectImageData) projectImageData.value = "";
    updateImagePreview("");
    clearProjectErrors();
    openProjectModal();
  }

  function openEditProject(id) {
    const project = store.getPortfolioData().projects.find((item) => item.id === id);
    if (!project) return;
    editingProjectId = id;
    if (projectFormTitle) projectFormTitle.textContent = "Редактирование проекта";
    fillProjectForm(project);
    clearProjectErrors();
    openProjectModal();
  }

  function deleteProject(id) {
    const data = store.getPortfolioData();
    const item = data.projects.find((entry) => entry.id === id);
    if (!item) return;

    const confirmed = window.confirm(`Удалить проект «${item.title}»?`); // eslint-disable-line no-alert
    if (!confirmed) return;

    data.projects = data.projects.filter((entry) => entry.id !== id);
    store.savePortfolioData(data);
    renderProjectsAdmin();
  }

  function handleProjectSubmit(event) {
    event.preventDefault();
    clearProjectErrors();

    const formData = new FormData(projectForm);
    const data = store.getPortfolioData();
    const categoryKeys = store.getCategoryKeys();
    const existing = editingProjectId
      ? data.projects.find((item) => item.id === editingProjectId)
      : null;

    const payload = store.normalizeProject({
      id: editingProjectId || store.createId(),
      title: formData.get("title"),
      shortDesc: formData.get("shortDesc"),
      category: formData.get("category") || categoryKeys[0],
      description: formData.get("description"),
      image: projectImageData?.value || "",
      imageIndex: existing?.imageIndex ?? data.projects.length % (store.DEFAULT_IMAGES?.length || 3),
      gallery: existing?.gallery || [],
      showOnHome: Boolean(formData.get("showOnHome")),
    }, 0, categoryKeys);

    if (!payload.title) {
      showProjectError("title");
      return;
    }

    const index = data.projects.findIndex((item) => item.id === payload.id);
    if (index >= 0) {
      data.projects[index] = payload;
    } else {
      data.projects.push(payload);
    }

    store.savePortfolioData(data);
    closeProjectModal();
    renderProjectsAdmin();
  }

  document.querySelectorAll('[data-content-open="portfolio"]').forEach((button) => {
    button.addEventListener("click", showPortfolioEditor);
  });

  if (projectCreateBtn) {
    projectCreateBtn.addEventListener("click", openCreateProject);
  }

  if (projectForm) {
    projectForm.addEventListener("submit", handleProjectSubmit);
  }

  document.querySelectorAll("[data-portfolio-modal-close]").forEach((element) => {
    element.addEventListener("click", closeProjectModal);
  });

  if (projectList) {
    projectList.addEventListener("click", (event) => {
      const editBtn = event.target.closest("[data-portfolio-edit]");
      const deleteBtn = event.target.closest("[data-portfolio-delete]");
      if (editBtn) openEditProject(editBtn.getAttribute("data-portfolio-edit"));
      if (deleteBtn) deleteProject(deleteBtn.getAttribute("data-portfolio-delete"));
    });
  }

  if (projectImageInput) {
    projectImageInput.addEventListener("change", () => {
      const file = projectImageInput.files?.[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = () => {
        const result = String(reader.result || "");
        if (projectImageData) projectImageData.value = result;
        updateImagePreview(result);
      };
      reader.readAsDataURL(file);
    });
  }

  if (projectImageReset) {
    projectImageReset.addEventListener("click", () => {
      if (projectImageData) projectImageData.value = "";
      if (projectImageInput) projectImageInput.value = "";
      updateImagePreview("");
    });
  }

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    if (projectModal && !projectModal.hidden) closeProjectModal();
  });

  document.addEventListener("nm:categories-updated", () => {
    if (portfolioEditor && !portfolioEditor.hidden) renderProjectsAdmin();
  });

  window.NMAdminPortfolioContent = {
    showPortfolioEditor,
    renderProjectsAdmin,
    closeProjectModal,
  };
}

if (adminRoot) {
  initAdminPortfolioContent();
  window.setTimeout(initAdminPortfolioContent, 0);
}
